import { useSetState, useMount } from 'react-use'

const useValidate = (validationSchema, values) => {
    const [state, setState] = useSetState({
        validating: true,
        isValid: null,
    })

    const { validating, isValid } = state

    useMount(() => {
        const validate = async () => {
            try {
                await validationSchema.validate(values)
                    .then(() => {
                        setState({
                            validating: false,
                            isValid: true,
                        })
                    })
            } catch (e) {
                setState({
                    validating: false,
                    isValid: false,
                })
            }
        }

        validate()
    })

    return [validating, isValid]
}

export default useValidate
